var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 row mx-0 px-0",attrs:{"id":"article-create"}},[_c('article-content',{attrs:{"articleId":_vm.articleId},on:{"edited":_vm.edited,"updated":_vm.updateCurrentArticle,"cover":_vm.setPreviewCover}}),_vm._v(" "),_c('article-preview',{attrs:{"coverUrl":_vm.coverUrl,"content":_vm.previewContent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1211390d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/view/article/ArticleCreate.vue
// module id = null
// module chunks = 